export default __webpack_public_path__ + "static/media/guideags_thumb.65e38367.jpg";